<template>
  <div>404</div>
</template>

<script>
export default {
  async asyncData({ res }) {
    res.status(404);
  },
};
</script>
